import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
const names = ['María de México', 'Carlos de Colombia', 'Ana de España', 'Juan de Argentina', 'Laura de Chile', 'Pedro de Perú'];
const times = ['hace 2 minutos', 'hace 5 minutos', 'hace 12 minutos', 'hace 1 minuto', 'hace 8 minutos'];
export function RecentPurchaseNotification() {
  const [isVisible, setIsVisible] = useState(false);
  const [notification, setNotification] = useState({
    name: '',
    time: ''
  });
  useEffect(() => {
    // Initial delay before first notification
    const initialDelay = setTimeout(() => {
      showNotification();
    }, 10000);
    return () => clearTimeout(initialDelay);
  }, []);
  const showNotification = () => {
    const randomName = names[Math.floor(Math.random() * names.length)];
    const randomTime = times[Math.floor(Math.random() * times.length)];
    setNotification({
      name: randomName,
      time: randomTime
    });
    setIsVisible(true);
    // Hide after 4 seconds
    setTimeout(() => {
      setIsVisible(false);
      // Schedule next notification (between 15 and 25 seconds)
      const nextDelay = Math.floor(Math.random() * 10000) + 15000;
      setTimeout(showNotification, nextDelay);
    }, 4000);
  };
  return <AnimatePresence data-id="element-255">
      {isVisible && <motion.div initial={{
      opacity: 0,
      y: 50,
      x: -20
    }} animate={{
      opacity: 1,
      y: 0,
      x: 0
    }} exit={{
      opacity: 0,
      y: 20,
      scale: 0.9
    }} transition={{
      duration: 0.4,
      type: 'spring',
      bounce: 0.4
    }} className="fixed bottom-5 left-5 z-50 bg-[#0B1224] border border-[#15203B] shadow-2xl rounded-lg p-4 flex items-center gap-4 max-w-[300px]" data-id="element-256">
          <div className="w-10 h-10 bg-green-500/20 rounded-full flex items-center justify-center flex-shrink-0 border border-green-500/30" data-id="element-257">
            <span className="text-green-500 text-xl" data-id="element-258">✓</span>
          </div>
          <div data-id="element-259">
            <p className="text-white text-sm font-medium" data-id="element-260">
              <span className="font-bold" data-id="element-261">{notification.name}</span> compró el
              protocolo
            </p>
            <p className="text-gray-400 text-xs mt-1" data-id="element-262">{notification.time}</p>
          </div>
        </motion.div>}
    </AnimatePresence>;
}